export default source => {
    let res = source.match(/events\/([\w-]*)/);
    return res ? res[1] : null;
};
